var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCombined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 38,
    xmlns: "http://www.w3.org/2000/svg",
    fillRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.364 36.876V1a1 1 0 00-1-1h-4.83a1 1 0 00-1 1v35.876h-4.468V8.886a1 1 0 00-1-1h-4.831a1 1 0 00-1 1v27.99h-4.47V17.09a1 1 0 00-1-1h-4.83a1 1 0 00-1 1v19.785h-4.469V23.553a1 1 0 00-1-1h-4.83a1 1 0 00-1 1v13.323H.418c-.23 0-.419.253-.419.562 0 .309.188.562.419.562H49.58c.23 0 .419-.253.419-.562 0-.312-.186-.562-.419-.562h-4.217z"
  })));
}
export default SvgCombined;